import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Projects } from './components/projects'
import { About } from './components/about'
import { Contact } from './components/contact'
import data from './data/data.json'
import './App.css'

const App = () => (
  <div className="shell">
    <div className="backdrop" aria-hidden="true" />
    <a className="skip-link" href="#work">
      Skip to content
    </a>

    <Navigation company={data.company} />

    <main>
      <Header company={data.company} />
      <Projects work={data.work} />
      <About company={data.company} />
      <Contact company={data.company} />
    </main>
  </div>
)

export default App
